export enum CompanyTypes {
    insurance = 'insurance',
    pension = 'pension',
    bank = 'bank',
    credit = 'credit',
}

export interface Company {
    _id: string;
    name: string;
    type: CompanyTypes;
    pensionProcessingEmail?: string;
    gemelProcessingEmail?: string;
    logoUrl?: string;
    thumbUrl?: string;
    shortName?: string;
    signnowTemplates: {
        lifeInsurance: {
            join: string[];
            quastionnaires: string[];
            fullCancellation: string;
            partialCancellation: string;
            agentAppointment: string;
        };
        healthInsurance: {
            join: string[];
            quastionnaires: string[];
            fullCancellation: string;
            partialCancellation: string;
            agentAppointment: string;
        };
    };
}
